export default "__VITE_ASSET__DsHj7vde__"